import { render, staticRenderFns } from "./mainPageContent.vue?vue&type=template&id=89957e44&scoped=true"
import script from "./mainPageContent.vue?vue&type=script&lang=js"
export * from "./mainPageContent.vue?vue&type=script&lang=js"
import style0 from "./mainPageContent.vue?vue&type=style&index=0&id=89957e44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89957e44",
  null
  
)

export default component.exports